import IBuyFeatureData from '../../../../vendor_core/core/src/server/data/IBuyFeatureData';
import { IBaseDataParser } from '../../../../vendor_core/core/src/server/parsers/IBaseDataParser';

export default class TRWBuyFeatureParser implements IBaseDataParser<IBuyFeatureData> {
    check(data: any): boolean {
        return true;
    }

    parse(data: any): IBuyFeatureData | IBuyFeatureData[] {
        return [{
            buyFeature: true,
            mode: -1
        }];
    }
}
